import script from "./AgentActionMenu.linux.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentActionMenu.linux.vue?vue&type=script&setup=true&lang=ts"

import "./AgentActionMenu.linux.vue?vue&type=style&index=0&id=6cdd642a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cdd642a"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QItem});
